// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"e3d67166","528":"6fbe840a","577":"2719fe30","595":"e3d67166","677":"2719fe30","985":"6fbe840a"}[chunkId] + ".chunk.css";
};